import React, { useEffect, useState } from "react";
import SavedMunis from "../components/SavedSeries";
import { UserAuth } from "../context/AuthContext";
import PlansScreen from "../components/PlansScreen";
import AuthorizedSeries from "../components/AuthorizedSeries";
import { useTranslation } from "../hooks/useTranslation";

const Account = () => {
  const { user } = UserAuth();
  const { t } = useTranslation();

  return (
    <>
      <div className="w-full text-white">
        <video
          className="w-full h-[400px] object-cover"
          autoPlay
          muted
          loop
          loading="lazy"
        >
          <source src="./www.grownasspizzaparty.com.webm" type="video/webm" />
          <source src="./www.grownasspizzaparty.com.mp4" type="video/mp4" />
          <img
            src="./background.jpg"
            alt="iSiLIVE Live Banner"
            className="w-full h-[400px] object-cover"
          />
        </video>

        <div className="bg-black/60 absolute top-0 left-0 w-full h-[400px]">
          <div className="absolute top-[20%] p-4 md:p-8"></div>
        </div>
        <h1 className="text-3xl md:text-5xl font-bold pl-4 py-4">
          {t("accountGreeting")} {user.email}
        </h1>
        <div>{/* <PlansScreen /> */}</div>
        <div>
          <h2 className="pl-4 py-2">
            {t("accountSeeLiveArchived")}{" "}
            <a className="text-blue-500" href="/">
              {t("homepage")}
            </a>{" "}
            {t("accountOrViewSavedBelow")}
          </h2>
        </div>

        {/* Display authorized series */}
        <AuthorizedSeries />

        {/* Display saved series */}
        <div>
          <SavedMunis />
        </div>
      </div>
      <br></br>
    </>
  );
};

export default Account;